export default "__VITE_ASSET__BIBA4Ff2__"